// extracted by mini-css-extract-plugin
module.exports = {"gallery":"Gallery_gallery__1AYwU","img":"Gallery_img__2lxmt","center":"Gallery_center__lvEtd"};